module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_peru-61f30e2d.png";